import React from 'react';
import { Button as JoyButton, ButtonProps as JoyButtonProps } from '@mui/joy';
import { cn } from '@utils/cn';

interface ButtonProps extends JoyButtonProps {
  variant?: 'solid' | 'soft' | 'outlined' | 'plain';
  color?: 'primary' | 'neutral' | 'danger' | 'success' | 'warning';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  fullWidth?: boolean;
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'solid',
  color = 'primary',
  size = 'md',
  loading = false,
  fullWidth = false,
  className,
  disabled,
  ...props
}) => {
  return (
    <JoyButton
      variant={variant}
      color={color}
      size={size}
      loading={loading}
      fullWidth={fullWidth}
      disabled={disabled || loading}
      className={cn(
        'transition-all duration-200',
        'hover:shadow-md active:scale-95',
        'font-medium',
        className
      )}
      {...props}
    >
      {children}
    </JoyButton>
  );
};